export default "__VITE_ASSET__B_yWhS7g__";